<template>
  <div>
    <footer class="main-footer">
      <div class="container">
        <div class="row">
          <div class="m-0 text-left col-12 col-lg-9">
            <p>
              Agora que você conheceu nossa página de carreiras, venha criar
              negócios de <br />
              valores com a gente:
            </p>
            <div class="d-md-flex align-items-center">
              <a href="https://www.travelexbank.com.br/" target="_blank">
                <img
                  src="@/assets/images/logo2.png"
                  alt="confidence Logotipo"
                  style="max-width: 140px"
                  class="mr-md-5"
                />
              </a>
              <a href="https://www.confidencecambio.com.br/" target="_blank" style="margin-left:-31px;">
                <img
                  src="@/assets/images/logo.png"
                  alt="confidence Logotipo"
                  style="max-width: 280px"
                  class="mr-md-5 travelex-logo"
                />
              </a>
            </div>
            <p class="copy d-none d-lg-block">
              Grupo Travelex Confidence © - todos os direitos reservados -
              regularmente inscrita no CNPJ nº. 04.913.129/0001-41, TRAVELEX
              BANCO DE CÂMBIO S/A. Engenheiro Luiz Carlos Berrini, nº 105, Cj 51
              e 52, 5º andar, São Paulo/SP, CEP 04.571-010
            </p>
          </div>

          <div class="col-12 col-lg-3 mt-5 mt-lg-0">
            <nav class="navbar navbar-dark p-0 m-0">
              <ul class="">
                <li class="nav-item">
                  <router-link :to="'/#quem-somos'"> Quem Somos </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="'/vagas'"> Vagas </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="'/programas'"> Programas </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="'/diversidade'"> Diversidade </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="'/faq'"> FAQ </router-link>
                </li>
                <li>
                  <router-link
                    to="/deixe-seu-perfil"
                    class="btn btn-cyan-ml register"
                    >Cadastre seu currículo</router-link
                  >
                </li>
                <a
                  class="d-none d-lg-block jobs"
                  href="https://www.99jobs.com/"
                  target="_blank"
                >
                  Desenvolvido por <strong>99jobs</strong>
                </a>
              </ul>
            </nav>

            <p class="copy d-block d-lg-none">
              Grupo Travelex Confidence © - todos os direitos reservados -
              regularmente inscrita no CNPJ nº. 04.913.129/0001-41, TRAVELEX
              BANCO DE CÂMBIO S/A. Engenheiro Luiz Carlos Berrini, nº 105, Cj 51
              e 52, 5º andar, São Paulo/SP, CEP 04.571-010
            </p>
            <a
              class="d-block d-lg-none jobs"
              href="https://www.99jobs.com/"
              target="_blank"
            >
              Desenvolvido por <strong>99jobs</strong>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import FacebookIcon from "vue-material-design-icons/Facebook.vue";
import InstagramIcon from "vue-material-design-icons/Instagram.vue";
import LinkedinIcon from "vue-material-design-icons/Linkedin.vue";
import TwitterIcon from "vue-material-design-icons/Twitter.vue";
import PlayIcon from "vue-material-design-icons/Play.vue";

export default {
  name: "MainFooter",

  computed: {
    galeriaTimes() {
      return this.$store.state.teams;
    },
  },

  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    PlayIcon,
  },
};
</script>


<style lang="scss" scoped>
.main-footer {
  background-color: theme-color(secondary);
  border-top: 8px solid theme-color(primary);
  color: #fff;
  padding: 4rem 0px;
    font-family: 'Lato', sans-serif;
  @include media-breakpoint-down(md) {
    text-align: center;
    padding: 1rem 0px;
  }
  p {
    font-size: 1.1rem;
    line-height: calc(1.1rem * 1.4);
    font-weight: 300 !important;
    margin-top: 1.5rem;
    color: #fff;
    &.copy {
      font-size: 0.9rem;
      line-height: calc(0.9rem * 1.4);
      margin-top: 5rem;
    }
  }
  h4 {
      font-family: 'Lato', sans-serif;
    font-style: italic;
    font-weight: 500;
    margin: 0px 0px 2rem 0.8rem;
  }
}

.travelex-logo {
 height: 51.8px;
 @media screen {
   margin-left: 5px;
   margin-top: -1.5px;
 }
  @media screen and (min-width: 431px) and (max-width: 435px) {
   margin-left: 1px;
 }
 @media screen and (max-width: 430px) {
   margin-left: -0.7px;
 }
}

a.register {
  background: #48b2eb;
  border-radius: 6px !important;
  color: #fff !important;
  padding: 0.5rem 2.5rem;
  margin: 0 auto;
  display: block;
  margin-top: 1.5rem;
  &:hover {
    background-color: lighten(#48b2eb, 9);
  }
}
ul {
  padding: 0px;
}
li {
  margin: 0px;
  padding: 0px;
  text-align: left;
  a {
    margin-bottom: 0.4rem;
    display: block;
    font-size: 1rem;
    font-weight: 400;
    color: #fff;
    &:hover {
      color: theme-color(primary);
    }
    img {
      width: 30px;
    }
  }
}
a.jobs {
  color: #48b2eb;
  font-size: 0.85rem;
  margin-top: 2rem;
  font-weight: 400 !important;
  font-family: "Lato", sans-serif;
  strong {
    font-size: 0.9rem;
  }
  @include media-breakpoint-up(lg) {
    float: right;
  }
}
.nav-link {
  color: #fff !important;
  padding: 0px !important;
  font-size: 1rem;
  font-weight: 400;
  &:hover {
    color: theme-color(primary) !important;
  }
}
</style>